import { render, staticRenderFns } from "./heatmap_multi_display.vue?vue&type=template&id=477bf962&lang=pug&"
import script from "./heatmap_multi_display.vue?vue&type=script&lang=js&"
export * from "./heatmap_multi_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports